<template>
  <div class="url" v-loading="loading">
    <iframe
      class="screen"
      id="biIframe"
      :src="url"
      allowfullscreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "url",
  inject: ["app"],
  data() {
    return {
      url: ""
    }
  },
  computed: {
    loading() {
      return !this.url
    }
  },
  watch: {
    $route() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let url = this.$route.params.url
      // 轻单大屏(report.dream-maker.com)分享链接不需要token
      if (url.indexOf("report") < 0) {
        // add token param
        const param = `jwt=${this.$store.getters.token}&appId=${this.app.id}`
        url += url.indexOf("?") >= 0 ? `&${param}` : `?${param}`
      }
      this.url = url
    }
  }
}
</script>

<style lang="scss" scoped>
.url {
  height: 100%;
  position: relative;
  .screen {
    width: 100%;
    height: 100%;
    border: unset;
  }
}
</style>
